import React from 'react';
import { Link } from 'react-router-dom';
import { branch, renderComponent } from 'recompose';
import { Col, Row, FormCheck } from 'react-bootstrap';
import SMSOptIn from '../sms-opt-in';
import './style.css';

const DisplayNothing = () => null;

const determineTermsAndConditionsLink = (companyCode) => {
  if (companyCode && companyCode === 'Dominion Energy') {
    return (
      <a
        href='https://public-bitsy-images.s3.amazonaws.com/legal/DominionEnergy_TermsAndConditions.pdf'
        target='_blank'
        rel='noopener noreferrer'
        className='termsAndConditions dominionEnergyTerms'
      >
        Terms & Conditions
      </a>
    );
  }
  return (
    <Link to='/terms-of-service' target='_blank' className='termsAndConditions'>
      Terms & Conditions
    </Link>
  );
};

const DisplayCheckboxes = (props) => (
  <Col className='checkboxesSignUp'>
    {props.termsAndConditionsError ? (
      <Row className='form-error'>{props.termsAndConditionsError}</Row>
    ) : null}
    {props.companyCode ? null : (
      <Row>
        <Col className='isSubscribedToNewsletterCol'>
          <FormCheck aria-label='I want shipping updates and Bump Boxes info!'>
            <FormCheck.Label>
              <FormCheck.Input
                checked={
                  props.formValues
                    ? props.formValues.isSubscribedToNewsletter
                    : true
                }
                onChange={props.toggleSubscriptionToNewsletter}
                id='isSubscribedToNewsletter'
                isStatic={false}
              />
              I want shipping updates and Bump Boxes info!
            </FormCheck.Label>
          </FormCheck>
        </Col>
      </Row>
    )}
    {props.showSMSOptIn ? (
      <SMSOptIn
        handleSMSOptInToggle={props.handleSMSOptInToggle}
        isSmsOptInSelected={props.isSmsOptInSelected}
        containerId='signUpSMSOptInContainer'
      />
    ) : null}
    <Row>
      <Col className='isAgreedToTermsAndConditionsCol'>
        <FormCheck
          id='isAgreedToTermsAndConditions'
          aria-label='I agree to Terms and Conditions'
        >
          <FormCheck.Label>
            <FormCheck.Input
              checked={
                props.formValues
                  ? props.formValues.isAgreedToTermsAndConditions
                  : false
              }
              onChange={props.toggleTermsAndConditions}
              isStatic={false}
            />
            I agree to{'  '}
            {determineTermsAndConditionsLink(props.companyCode)}
          </FormCheck.Label>
        </FormCheck>
      </Col>
    </Row>
  </Col>
);

const isHideDisplayCheckboxes = (props) =>
  props.isHideDisplayCheckboxes || false;

const DisplayCheckboxesOrNot = branch(
  isHideDisplayCheckboxes,
  renderComponent(DisplayNothing),
)(DisplayCheckboxes);

export default DisplayCheckboxesOrNot;
